import { Avatar } from 'src/design/atoms/Avatar';
import { Group } from 'src/design/atoms/Group';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { TextInput } from 'src/design/atoms/TextInput';
import { IconCheck, IconX } from '@tabler/icons-react';
import React from 'react';
import { useCreatePostComment } from 'src/api/queries/posts/usePostCommentMutations';
import { useAuth } from 'src/hooks/useAuth';

interface NewCommentProps {
  postId: string;
  jobId: number;
}

export const NewComment: React.FC<NewCommentProps> = ({ postId, jobId }) => {
  const { user } = useAuth();
  const [value, setValue] = React.useState('');
  const createComment = useCreatePostComment(jobId, postId);

  const confirmComment = () => {
    if (!user || !jobId || jobId <= 0) return;
    createComment.mutate(value, { onSuccess: () => setValue('') });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      confirmComment();
      e.preventDefault();
    }
  };

  if (!user) return null;

  return (
    <Group wrap="nowrap" gap="xs">
      <Avatar size="sm" color="blue" radius="xl">
        {user.firstName.slice(0, 1)}
      </Avatar>
      <TextInput
        placeholder="Add a comment..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        style={{ flex: 1 }}
        rightSectionWidth={80}
        rightSection={
          <Group gap="xs" wrap="nowrap">
            <BasicActionIcon
              variant="subtle"
              onClick={confirmComment}
              loading={createComment.isPending}
              disabled={value.length === 0}
            >
              <IconCheck size={16} />
            </BasicActionIcon>
            <BasicActionIcon
              variant="subtle"
              color="red"
              onClick={() => setValue('')}
              disabled={value.length === 0}
            >
              <IconX size={16} />
            </BasicActionIcon>
          </Group>
        }
      />
    </Group>
  );
};
